// extracted by mini-css-extract-plugin
module.exports = {"credIcon":"CredentialIcon_credIcon_1-WO7","fallback":"CredentialIcon_fallback_5cZXD"};